import { render, staticRenderFns } from "./inviteApplyJob.vue?vue&type=template&id=48b1f6b5&scoped=true"
import script from "./inviteApplyJob.vue?vue&type=script&lang=js"
export * from "./inviteApplyJob.vue?vue&type=script&lang=js"
import style0 from "./inviteApplyJob.vue?vue&type=style&index=0&id=48b1f6b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b1f6b5",
  null
  
)

export default component.exports